import React from 'react';
import classNames from 'classnames';
export default function ToggleButton(props) {
    var classes = classNames({
        'toggle-button close': true,
        'fe fe-chevron-up': props.open,
        'fe fe-chevron-down': !props.open,
    });
    return React.createElement("div", { className: classes, onClick: props.onClick });
}
